import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div style={s.wrapper}>
      <header style={s.header}>
        <div onClick={() => navigate("/app/")} style={{ cursor: "pointer" }}>
          <Logo size={28} showText={true} />
        </div>
      </header>
      <main style={s.main}>
        <h1 style={s.h1}>Privacy Policy</h1>
        <p style={s.meta}>Last updated: January 1, 2025</p>

        <p style={s.p}>BotSaathi ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our WhatsApp automation platform.</p>

        <h2 style={s.h2}>1. Information We Collect</h2>
        <p style={s.p}>We may collect the following types of information:</p>
        <ul style={s.ul}>
          <li style={s.li}><strong>Business Information:</strong> Name, business name, city, and contact details provided during onboarding.</li>
          <li style={s.li}><strong>WhatsApp Data:</strong> Phone number IDs and access tokens required to operate your WhatsApp Business account via Meta's Cloud API.</li>
          <li style={s.li}><strong>Lead Data:</strong> Customer names, phone numbers, and inquiry details captured through your bot conversations.</li>
          <li style={s.li}><strong>Usage Data:</strong> Logs of bot interactions, message counts, and platform analytics.</li>
        </ul>

        <h2 style={s.h2}>2. How We Use Your Information</h2>
        <ul style={s.ul}>
          <li style={s.li}>To operate and maintain your WhatsApp bot.</li>
          <li style={s.li}>To capture and display leads in your dashboard.</li>
          <li style={s.li}>To send hot lead notifications via email, WhatsApp, or Telegram.</li>
          <li style={s.li}>To sync lead data with your Google Sheet.</li>
          <li style={s.li}>To improve our platform and customer support.</li>
        </ul>

        <h2 style={s.h2}>3. Data Sharing</h2>
        <p style={s.p}>We do not sell, trade, or rent your personal information to third parties. We may share data with:</p>
        <ul style={s.ul}>
          <li style={s.li}><strong>Meta (WhatsApp):</strong> To operate the WhatsApp Business API on your behalf.</li>
          <li style={s.li}><strong>Google:</strong> For Google Sheets integration (only if you enable it).</li>
          <li style={s.li}><strong>AI Providers:</strong> Anonymized conversation context sent to AI services for response generation.</li>
        </ul>

        <h2 style={s.h2}>4. Data Security</h2>
        <p style={s.p}>We implement industry-standard security measures including encrypted storage, secure API connections, and access controls. However, no method of transmission over the internet is 100% secure.</p>

        <h2 style={s.h2}>5. Data Retention</h2>
        <p style={s.p}>We retain your data for as long as your account is active. Upon account termination, data is deleted within 30 days unless required by law.</p>

        <h2 style={s.h2}>6. Your Rights</h2>
        <p style={s.p}>You have the right to access, correct, or delete your personal data at any time. Contact us at the email below to exercise these rights.</p>

        <h2 style={s.h2}>7. WhatsApp & Meta Policy Compliance</h2>
        <p style={s.p}>BotSaathi operates under Meta's WhatsApp Business Platform policies. By using our service, you agree to comply with Meta's terms of service and WhatsApp's business policies.</p>

        <h2 style={s.h2}>8. Contact Us</h2>
        <p style={s.p}>For privacy-related queries, contact us at:<br />
        <a href="mailto:support@botsaathi.com" style={s.link}>support@botsaathi.com</a><br />
        Ramnagar, Uttarakhand, India</p>
      </main>
      <footer style={s.footer}>
        <span style={{ color: "#444" }}>© 2025 BotSaathi. All rights reserved.</span>
        <a href="/terms-of-service" style={s.footerLink}>Terms of Service</a>
        <a href="/refund-policy" style={s.footerLink}>Refund Policy</a>
      </footer>
    </div>
  );
}

const s = {
  wrapper: { background: "#0a0a0a", minHeight: "100vh", color: "#d0d0d0" },
  header: { padding: "20px 40px", borderBottom: "1px solid #1a1a1a" },
  main: { maxWidth: 760, margin: "0 auto", padding: "60px 24px" },
  h1: { fontSize: 36, fontWeight: 700, color: "#fff", marginBottom: 8, fontFamily: "Georgia, serif" },
  h2: { fontSize: 20, fontWeight: 700, color: "#fff", marginTop: 36, marginBottom: 10 },
  meta: { fontSize: 13, color: "#555", marginBottom: 32 },
  p: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 16 },
  ul: { paddingLeft: 20, marginBottom: 16 },
  li: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 6 },
  link: { color: "#25d366", textDecoration: "none" },
  footer: { borderTop: "1px solid #1a1a1a", padding: "24px 40px", display: "flex", gap: 20, alignItems: "center", justifyContent: "center", flexWrap: "wrap" },
  footerLink: { fontSize: 13, color: "#555", textDecoration: "none" },
};
